import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section className="py-8 md:py-12 bg-[#faf8f6] relative overflow-hidden" data-id="element-165">
      {/* Background blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#d4a5a5]/10 rounded-full blur-[80px] -z-10" data-id="element-166" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#9d4b6b]/5 rounded-full blur-[60px] -z-10" data-id="element-167" />

      <div className="max-w-4xl mx-auto px-6" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-[#9d4b6b]/5 border border-[#d4a5a5]/20" data-id="element-169">
          <div className="text-center mb-10" data-id="element-170">
            <span className="text-[#9d4b6b] font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-171">
              Sobre la Autora
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-[#2d2d2d]" data-id="element-172">
              LA HISTORIA REAL QUE NACIÓ ESTE MÉTODO
            </h2>
          </div>

          <div className="prose prose-lg mx-auto text-[#5a5a5a]" data-id="element-173">
            <p data-id="element-174">
              <strong className="text-[#2d2d2d]" data-id="element-175">
                Carla, la autora de esta guía, vivió exactamente lo que tú estás
                viviendo ahora.
              </strong>
            </p>
            <p data-id="element-176">
              Cada noche lloraba en silencio. Se dormía de espaldas a su esposo,
              sintiendo su presencia física pero su ausencia emocional.
            </p>
            <p data-id="element-177">
              Probó de todo: Consejos. Terapia. Libros. Charlas. Cursos
              comprados en madrugadas de tristeza.
            </p>
            <p className="font-serif text-xl italic text-[#9d4b6b] text-center my-8" data-id="element-178">
              Nada funcionó.
            </p>
            <p data-id="element-179">
              Hasta que comenzó a escribir su dolor. A entenderlo. A separarse
              emocionalmente de él para reencontrarse con ella misma.
            </p>
            <p data-id="element-180">
              Ese fue su "divorcio emocional": no de su esposo, sino del dolor
              que cargaba.
            </p>
            <p data-id="element-181">
              Y desde ese lugar, elaboró un método específico para mujeres
              latinas, desde su experiencia y desde su fe.
            </p>
            <div className="bg-[#faf8f6] p-6 rounded-xl border-l-4 border-[#9d4b6b] mt-8" data-id="element-182">
              <p className="text-[#2d2d2d] font-medium m-0" data-id="element-183">
                Ese método salvó su matrimonio. Y hoy está ayudando a miles de
                mujeres a salvar el suyo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}